export const BRAND = {
  name: "Bima Bachat Bazar",
  tagline: "Chhoti investment se badi khushiyan",
  advisor: "Utkarsh Gupta",
  phone1: "8858187397",
  phone2: "7081311502",
  email: "bimabachatbazar@gmail.com",
  whatsapp: "918858187397",
  address: "Singh Market, Shop No. 4, Front of Post Office, Near Kashi Complex, Mughal Road, Bindki, Fatehpur, Uttar Pradesh – 212635",
};

export const ASSETS = {
  hero: "https://customer-assets-v7afamib.emergentagent.net/job_d940f23d-542e-4cbe-a965-12c7e4118028/artifacts/tqkz09qv_file_00000000a2ec72089ac419a360f5b106.png",
  profile: "https://customer-assets-v7afamib.emergentagent.net/job_d940f23d-542e-4cbe-a965-12c7e4118028/artifacts/wlg5m1a6_file_00000000496081fa94599de49ad3c9e0.png",
  logo: "https://customer-assets-v7afamib.emergentagent.net/job_d940f23d-542e-4cbe-a965-12c7e4118028/artifacts/bfo4qdws_IMG-20260213-WA0025%20%281%29.webp",
};

export const waLink = (text) =>
  `https://wa.me/${BRAND.whatsapp}?text=${encodeURIComponent(text || "Namaste Utkarsh ji, mujhe financial planning ke baare mein jaankari chahiye.")}`;

export const SERVICES = [
  {
    slug: "insurance",
    tone: "blue",
    title: "Insurance Services",
    hindi: "Suraksha ka bharosa",
    text: "Life, health, term, motor, shop & family protection plans — sahi cover, sahi daam par.",
    points: ["Term & Life Insurance", "Health & Mediclaim", "Motor / Vehicle Insurance", "Shop & Business Cover"],
  },
  {
    slug: "investment-mutual-funds",
    tone: "gold",
    title: "Investment & Mutual Funds",
    hindi: "Paisa badhane ki planning",
    text: "SIP, lumpsum, ELSS tax saver, child education aur retirement planning — goals ke hisaab se.",
    points: ["SIP from ₹500/month", "Lumpsum & SWP", "ELSS Tax Saving", "Retirement & Child Plans"],
  },
  {
    slug: "tax-gst",
    tone: "green",
    title: "Tax & GST",
    hindi: "Tax ka tension khatam",
    text: "ITR filing, GST registration & returns — time par, bina jhanjhat, expert guidance ke saath.",
    points: ["ITR Filing (All)", "GST Registration", "GST Return Filing", "Accounting Support"],
  },
  {
    slug: "banking-csc",
    tone: "navy",
    title: "Banking, CSC & Digital",
    hindi: "Sarkari aur digital seva",
    text: "PAN card, Voter ID, Ayushman card, AePS cash withdrawal, utility bills — sab ek hi jagah.",
    points: ["New / Correction PAN", "Voter ID & Ayushman", "AePS & Banking", "Utility Bill Payments"],
  },
];

export const INTEREST_OPTIONS = [
  "Life Insurance", "Health Insurance", "Term Insurance", "Mutual Fund", "Investment Planning",
  "Retirement Planning", "Tax / ITR", "GST", "Banking / Post Office", "Other Service",
];

export const FAQS = [
  ["SIP शुरू करने के लिए कितना पैसा चाहिए?", "आप ₹500 प्रति माह से SIP शुरू कर सकते हैं। सही राशि आपके goal, समय और cash flow के हिसाब से तय होती है।"],
  ["क्या insurance और investment अलग चीजें हैं?", "जी हाँ। Insurance financial protection देता है, जबकि investment wealth creation के लिए होता है। हम दोनों की जरूरत अलग-अलग समझाकर सलाह देते हैं।"],
  ["क्या ये website पर दिखाए returns guaranteed हैं?", "नहीं। Calculator और performance data केवल illustration और education के लिए हैं। Market-linked returns की कोई guarantee नहीं होती।"],
  ["PAN card / Voter ID banwane mein kitna time lagta hai?", "CSC seva ke through PAN card aam taur par 7-15 din mein aa jata hai. Voter ID ka samay state process par nirbhar karta hai. Hum status update dete rehte hain."],
  ["मैं advisor partner कैसे बन सकता हूँ?", "Partner page par enquiry भेजें। हमारी team आपकी eligibility, training और onboarding के बारे में बात करेगी।"],
];

export const TESTIMONIALS = [
  { quote: "Utkarsh ji ne insurance aur SIP dono ko bahut simple tarike se samjhaya. Ab future ko lekar confidence hai.", name: "Ravi Kumar", role: "Business owner, Bindki" },
  { quote: "Tax filing aur GST registration ek hi jagah par bina confusion ke ho gaya. Bahut responsive team.", name: "Neha Singh", role: "Small business owner" },
  { quote: "PAN card aur Ayushman card ghar baithe ban gaya. CSC service bahut fast aur reliable hai.", name: "Sunita Devi", role: "Homemaker, Fatehpur" },
  { quote: "Mere goals ke hisaab se planning mili, sirf product sell karne wali baat nahi hui.", name: "Amit Verma", role: "Salaried professional" },
];

export const PLATFORMS = [
  { name: "Centricity", desc: "Investment & wealth platform", url: "https://1digi.co.in/363pjzbn", tag: "Investment" },
  { name: "Policybazaar Partners", desc: "Compare & buy insurance plans", url: "https://www.pbpartners.com/v2/partner/utkarsh-fatehpur-erz", tag: "Insurance" },
  { name: "NJ Wealth", desc: "Mutual fund investment partner", url: "http://p.njw.bz/83479", tag: "Mutual Funds" },
  { name: "SBI Life Insurance", desc: "Life insurance plans (Life Mitra)", url: "http://utkarsh991014977.lifemitra.com", tag: "Insurance" },
  { name: "Angel One", desc: "Stock trading & broking", url: "https://www.angelone.in/trade", tag: "Stocks" },
  { name: "Angel One Demat", desc: "Open a free Demat account", url: "https://angel-one.onelink.me/Wjgr/upbwoocv", tag: "Demat" },
  { name: "SBI Mutual Fund", desc: "SBI MF official app & plans", url: "https://sbimf.app/23E68DkT2mxA", tag: "Mutual Funds" },
  { name: "Turtlemint (PoSP)", desc: "Insurance advisor profile", url: "https://advisor.turtlemintinsurance.com/profile/UTK0430733/UTKARSH_GUPTA_BIMA_BACHAT_BAZAR_", tag: "Insurance" },
  { name: "ZFunds", desc: "Personalized mutual fund advice", url: "https://zfunds.in/visiting-card/a8d04898-8831-49f7-a693-01125905fc42", tag: "Mutual Funds" },
  { name: "Religare (AePS Agent)", desc: "Become an AePS banking agent", url: "https://religare.ref-r.com/c/i/32536/128519242", tag: "Banking" },
  { name: "INDmoney (US Stocks)", desc: "Invest in US stocks", url: "https://indmoney.onelink.me/RmHC/fs8peeyg", tag: "Stocks" },
];

export const SOCIALS = [
  { name: "Facebook", url: "https://www.facebook.com/share/1J83Vdvt1y/" },
  { name: "YouTube", url: "https://youtube.com/@bimabachatbazar?si=hGMLflb1SKVSH-Tg" },
  { name: "Instagram", url: "https://www.instagram.com/bimabachatbazar?stkn=MWtkbXZmbml4czc0bg==" },
  { name: "WhatsApp", url: "https://wa.me/message/2Z3PLJSQNJ2QC1" },
  { name: "Threads", url: "https://www.threads.com/@bimabachatbazar" },
  { name: "Pinterest", url: "https://pin.it/O3EGG2Usr" },
  { name: "X (Twitter)", url: "https://x.com/UtkarshBima" },
  { name: "LinkedIn", url: "https://www.linkedin.com/in/bima-bachat-bazar-667204191?utm_source=share_via&utm_content=profile&utm_medium=member_android" },
];

export const LEGAL = {
  privacy: {
    title: "Privacy Policy",
    updated: "Last Updated: September 2026",
    sections: [
      ["", "Bima Bachat Bazar respects your privacy. This Privacy Policy explains how information submitted through our website may be collected and used."],
      ["Information We May Collect", "When you contact us or submit an enquiry, we may receive information such as: Name, Mobile number, Email address, Service requirement, and information voluntarily provided through enquiry forms or communication."],
      ["How Information May Be Used", "Information may be used to: respond to enquiries; provide requested information or assistance; communicate regarding requested services; improve our website and customer experience; and maintain records where required for legitimate business or legal purposes. We do not intentionally request sensitive personal information through the general website enquiry form unless necessary for a specific service."],
      ["Third-Party Services", "Our website may use third-party services such as WhatsApp, Google Maps, analytics, hosting or other service providers. Their respective privacy policies may also apply."],
      ["Data Security", "We take reasonable measures to protect information submitted through our website. However, no internet transmission or electronic storage system can be guaranteed to be completely secure."],
      ["Contact", "For privacy-related questions, contact: Bima Bachat Bazar, Singh Market, Shop No. 4, Front of Post Office, Near Kashi Complex, Mughal Road, Bindki, Fatehpur, Uttar Pradesh – 212635. Email: bimabachatbazar@gmail.com. Phone: 8858187397 / 7081311502."],
    ],
  },
  terms: {
    title: "Terms & Conditions",
    updated: "",
    sections: [
      ["", "By using this website, you acknowledge that the information provided on the website is for general informational and service-assistance purposes."],
      ["Financial Services", "Financial products and investments are subject to applicable market risks, product terms and regulatory requirements. Users should review relevant documents and disclosures before making financial decisions."],
      ["Insurance", "Insurance products are subject to policy terms, conditions, exclusions and applicable eligibility requirements."],
      ["Investment", "Investment-related information does not constitute a guarantee of returns. Market-linked investments can involve risk, and suitability depends on individual circumstances and applicable regulations."],
      ["Tax & GST", "Tax and GST-related assistance is subject to applicable laws, rules, regulations and information/documents provided by the client."],
      ["Service Availability", "Services are subject to applicable eligibility, documentation, authorization, regulatory requirements and availability."],
      ["Website Information", "We make reasonable efforts to keep website information accurate and current, but information may change without prior notice."],
      ["External Links", "The website may contain links to third-party websites or platforms. Bima Bachat Bazar is not responsible for the content or privacy practices of third-party websites."],
      ["Contact", "For questions regarding these Terms & Conditions: Bima Bachat Bazar, Singh Market, Shop No. 4, Front of Post Office, Near Kashi Complex, Mughal Road, Bindki, Fatehpur, Uttar Pradesh – 212635. Phone: 8858187397 / 7081311502. Email: bimabachatbazar@gmail.com."],
    ],
  },
  disclaimer: {
    title: "Investment & Insurance Disclaimer",
    updated: "",
    sections: [
      ["", "Financial products and investments are subject to market risks and applicable regulatory terms. Please read all relevant documents and disclosures carefully before investing."],
      ["Insurance", "Insurance products are subject to policy terms, conditions and exclusions."],
      ["Past Performance", "Past performance, wherever applicable, should not be treated as an indication or guarantee of future results."],
      ["Partner / Agent Opportunities", "Partner/Agent opportunities, commissions and earnings are subject to eligibility, performance, agreements, applicable laws, regulations and authorization requirements. Actual earnings may vary and are not guaranteed."],
    ],
  },
};
